import { render, staticRenderFns } from "./pcStickyBtns.vue?vue&type=template&id=a0a96ef6&scoped=true&"
import script from "./pcStickyBtns.vue?vue&type=script&lang=js&"
export * from "./pcStickyBtns.vue?vue&type=script&lang=js&"
import style0 from "./pcStickyBtns.vue?vue&type=style&index=0&id=a0a96ef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a96ef6",
  null
  
)

component.options.__file = "pcStickyBtns.vue"
export default component.exports